module.exports = __webpack_public_path__ + "img/logoname.e633f5b9.svg";